var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('window-frame',{attrs:{"titleText":"画像プレビュー","display-property":"private.display.imageViewWindow","align":"center","baseSize":"418, 339"}},[_c('div',{staticClass:"contents"},[_c('img',{attrs:{"src":_vm.imageData,"alt":""}})])])}
var staticRenderFns = []

export { render, staticRenderFns }